import { useTranslations } from "hooks";

export const useDateDiff = () => {

    const [
        YEARS,
        MONTHS,
        WEEKS
    ] = useTranslations(i18n)

    const getDiffDate = (date1: Date, date2: Date): string => {
        const secondes = Math.round((date1.getTime() - date2.getTime()) / 1000 );
        const d = Math.floor(secondes / (3600*24));
        const h = Math.floor(secondes % (3600*24) / 3600);
        const mn = Math.floor(secondes % 3600 / 60);
        const s = Math.floor(secondes % 60);
        const w = Math.floor(d / 7);
        const m = Math.floor(d / 30);
        const y = Math.floor(d / 365);
    
        return  y > 0 ? `${y} ${YEARS} `:  m > 0 ? `${m} ${MONTHS} ` 
            :  w > 0 ? `${w} ${WEEKS}` : d > 0 ? `${d}j ` 
            : h > 0 ? `${h}h ` : mn > 0 ? `${mn}mn ` : s > 0 ? `${s}s` : ''
    }

    return getDiffDate
}

const i18n = [
    'SDS1Click.Common.Years.label',
    'SDS1Click.Common.Months.label',
    'SDS1Click.Common.Weeks.label',
]
